import React, { useEffect, useState } from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { Button } from "semantic-ui-react";
import { HiChevronLeft } from "react-icons/hi";
import { useNavigate } from "react-router";
import OriginInputCustom from "../../../components/InputComponents/originInputCustom";
import {
  transactionExpress,
  transactionExpressForInput,
} from "../../../regex_constanst";
import { useDispatch, useSelector } from "react-redux";
import { notice } from "../../../redux/action/action";
import { MD5 } from "crypto-js";
import { useTranslation } from "react-i18next";
import { bindCardInformation } from "../../../api/postApi";
import { customCryptoPassword } from "../../../utils/customCryptoPassword";
import dayjs from "dayjs";

const SetTransactionPassword = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`settings.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_formHint = (key, props) => t(`formHint.${key}`, { ...props });

  const memberData = useSelector((state) => state.isMemberInfo);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [data, setData] = useState({
    secret_pwd: "",
    secret_pwd_again: "",
  });
  const [buttonLoading, setButtonLoading] = useState(false);

  const [uploadIdCard, setUploadIdCard] = useState(null);

  const { secret_pwd, secret_pwd_again } = data;

  const handleInputTransactionPassword = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
    localStorage.setItem(name, customCryptoPassword(value).toString());
  };

  useEffect(() => {
    if (memberData.isBindAccount == 1) {
      navigate("../bind-id-card");
      return;
    }
    if (
      localStorage.getItem("step") === null &&
      memberData.isBindAccount == 0
    ) {
      navigate("../bind-id-card");
    }
  }, [memberData]);

  const uploadParamsList = [
    "bank_name",
    "bank_account_name",
    "bank_branch_name",
    "bank_account",
    "bank_card_number",
    "id_card",
    "secret_pwd",
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    setButtonLoading(true);
    const { secret_pwd, secret_pwd_again } = data;
    if (transactionExpress.test(secret_pwd)) {
      if (secret_pwd === secret_pwd_again) {
        let bodyFormData = new FormData();

        for (let i = 0; i < uploadParamsList.length; i++) {
          bodyFormData.append(
            uploadParamsList[i],
            localStorage.getItem(uploadParamsList[i])
          );
        }
        bodyFormData.append("id_pic0", uploadIdCard);
        bodyFormData.append(
          "birth",
          dayjs(localStorage.getItem("birth")).format("YYYY-MM-DD")
        );

        bindCardInformation({
          formData: bodyFormData,
        })
          .then((data) => {
            dispatch({ type: "GET_MEMBER_DATA" });
            dispatch(notice(i18n_formHint("setSuccess"), "success"));
            navigate("../bind-success");
          })
          .catch((err) => {
            localStorage.clear();
          })
          .finally(() => {
            setButtonLoading(false);
          });
      } else {
        dispatch(notice(i18n_formHint("twoPassword"), "error"));
      }
    } else {
      dispatch(
        notice(i18n_formHint("passwordFormatError", { number: 4 }), "error")
      );
    }
  };

  const formData = [
    {
      name: "secret_pwd",
      label: "交易密碼",
      type: "password",
      placeholder: i18n("idCard.setTransactionPasswordHint"),
      pattern: transactionExpressForInput,
      value: secret_pwd,
      title: i18n("idCard.setTransactionPasswordHint"),
      onChange: (e) => {
        handleInputTransactionPassword(e);
      },
    },
    {
      name: "secret_pwd_again",
      label: "再次輸入交易密碼",
      type: "password",
      placeholder: i18n("idCard.setTransactionPasswordHint"),
      pattern: transactionExpressForInput,
      value: secret_pwd_again,
      onChange: (e) => {
        handleInputTransactionPassword(e);
      },
    },
  ];

  return (
    <DetailWrapper
      closeAnimate
      wrapperClassName={`h-full w-full md:absolute fixed top-0 left-0 max-h-full z-[1] bg-gradient-to-br`}
    >
      <CloseDetailPage
        hasPrev={
          <HiChevronLeft
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
        }
        title={`${i18n("bindIdCard")}`}
      />
      <article className="flex flex-col gap-[15px] p-[15px] text-transaction-text dark:text-base-light-white font-medium">
        <span className="text-xl text-main-color">
          {i18n("idCard.setTransactionPassword")}
        </span>
        <form onSubmit={(e) => handleSubmit(e)}>
          {formData.map((item, index) => {
            return (
              <div className="custom-picker-field ">
                <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
                  {i18n(`form.${item.name}`)}
                </span>
                <OriginInputCustom {...item} name={item.name} />
              </div>
            );
          })}
          {memberData.uploadBankFile == 1 && (
            <span className="text-sm text-transaction-text dark:text-base-light-white font-medium">
              {i18n("form.uploadIdCard")}
              <OriginInputCustom
                onChange={(e) => {
                  const selectedFile = e.target.files[0];
                  setUploadIdCard(selectedFile);
                }}
                type="file"
                name="upload"
              />
            </span>
          )}

          {memberData.uploadBankFile == 0 ? (
            <Button
              type="submit"
              loading={buttonLoading}
              disabled={!Object.keys(data).every((item) => data?.[item] !== "")}
              content={i18n_common("updateData")}
              size="xl"
              className="!bg-main-color !text-white !w-full !py-[17px] !mt-[20px]"
            ></Button>
          ) : (
            <Button
              type="submit"
              loading={buttonLoading}
              disabled={
                !Object.keys(data).every((item) => data?.[item] !== "") ||
                !uploadIdCard
              }
              content={i18n_common("updateData")}
              size="xl"
              className="!bg-main-color !text-white !w-full !py-[17px] !mt-[20px]"
            ></Button>
          )}
        </form>
      </article>
    </DetailWrapper>
  );
};

export default SetTransactionPassword;
